import React, { Fragment } from 'react'
import errorImage from './images/error.svg'

export default ({message = 'Oops something went wrong :('}) => {
    return (
        <Fragment>
            <img className='activation-image' src={errorImage} alt=''/>
            <div className='message-title'>{message}</div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/coupon/error.js